export const headers = {
  accept: 'application/json',
  revision: '2024-06-15', //https://developers.klaviyo.com/en/docs/api_versioning_and_deprecation_policy
  'content-type': 'application/json'
}